import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AdminApp } from "./admin/AdminApp";
import "./styles.css";

const isAdminPage = /^\/admin\/?$/.test(window.location.pathname);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isAdminPage ? <AdminApp /> : <App />}
  </StrictMode>,
);
